import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthState } from '../store/app/app.states';
import { catchError, filter, map, Observable, of, take, timeout } from 'rxjs';
import { getUserPermissions } from '../store/auth-state/auth.selectors';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class HasAnyPermissionGuard implements CanActivate {
  constructor(
    private readonly store: Store<AuthState>,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(getUserPermissions).pipe(
      // WAIT until permissions are resolved
      filter((permissions) => permissions !== null),
      take(1),
      map((permissions) => {
        if (permissions.length === 0) {
          return this.router.parseUrl('/no-access');
        }
        return true;
      })
    );
  }

  // canActivate(): Observable<boolean | UrlTree> {
  //   return this.store.select(getUserPermissions).pipe(
  //     filter((permissions) => permissions !== null),
  //     take(1),

  //     // important: do not allow navigation to hang forever
  //     timeout(3000),

  //     map((permissions) => {
  //       if (!permissions || permissions?.length === 0) {
  //         return this.router.parseUrl('/no-access');
  //       }

  //       return true;
  //     }),

  //     catchError(() => {
  //       return of(this.router.parseUrl('/no-access'));
  //     })
  //   );
  // }
}

